var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ediotable"}},[_c('img',{staticClass:"imageC",attrs:{"src":_vm.record.remarkflag || _vm.shShowBol ? _vm.icon_bianji1 : _vm.icon_bianji},on:{"click":_vm.shEvent}}),(_vm.shShowBol)?_c('shenhe',{attrs:{"island":_vm.shShowBol,"record":_vm.record},on:{"child":_vm.shEvent}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }